import { ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'
import EventBus from '@/store/EventBus'

export default function useDeleteDraft() {
  const deleting = ref(false)

  async function deleteDraft(id) {
    deleting.value = true
    try {
      await draftApi.delete(id)
      return true
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null
        ? data.message
        : 'A server error occurred. Please try again later.'
      EventBus.$emit('http-error', msg)
      return false
    } finally {
      deleting.value = false
    }
  }

  return { deleteDraft, deleting }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useDeleteDraft.js